import React from "react";
import { Modal, Button, Spinner } from "react-bootstrap";
import Icon from "@mdi/react";
import { mdiOpenInNew } from "@mdi/js";
import "./paymentConnection.css";

const CantRemovePaymentModal = ({ show, onHide, onManage, isLoading }) => (
  <Modal show={show} onHide={onHide} centered className="pc-modal">
    <Modal.Header closeButton>
      <Modal.Title>Can't Remove Payment Setup</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p className="mb-0">
        Your payment account has pending payouts or open disputes that need to be
        resolved first.
      </p>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="outline-secondary" onClick={onHide} disabled={isLoading}>
        Cancel
      </Button>
      <Button
        variant="primary"
        onClick={onManage}
        disabled={isLoading}
        className="d-inline-flex align-items-center gap-2"
      >
        {isLoading ? (
          <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
          />
        ) : (
          <>
            Manage Payments
            <Icon path={mdiOpenInNew} size={0.75} />
          </>
        )}
      </Button>
    </Modal.Footer>
  </Modal>
);

export default CantRemovePaymentModal;
